const getters = {
    token: state => state.user.token,
    name: state => state.user.name,
    roles: state => state.user.roles,
    companyName: state => state.user.companyName,
    userId: state => state.user.userId,
    userName: state => state.user.userName,
    auditStatus: state => state.user.auditStatus,
    applyInfo: state => state.user.applyInfo,
    menuActive: state => state.user.menuActive,
    isMonitoring: state => state.user.isMonitoring
}

export default getters
